import Vue from "vue";
import Vuex from "vuex";

import settings from "./modules/settings";
import messages from "./modules/messages";

Vue.use(Vuex);

export default new Vuex.Store({
  modules: {
    settings,
    messages
  },
  strict: process.env.NODE_ENV !== "production"
});
